import { AdSize, SizeOption, AVAILABLE_SIZES } from '../constants/formatConstants';

// Utilitários para manipulação de tamanhos
export const createSizeOptions = (sizes: readonly AdSize[]): SizeOption[] => {
    return sizes.map(size => ({
        value: `${size[0]}x${size[1]}`,
        label: `${size[0]}×${size[1]}`
    }));
};

export const getSizeSelectValue = (sizes: number[][]): SizeOption[] => {
    return sizes ? sizes.map(size => ({
        value: `${size[0]}x${size[1]}`,
        label: `${size[0]}×${size[1]}`
    })) : [];
};

export const convertSelectToSizes = (options: SizeOption[]): number[][] => {
    return options.map(option => {
        const [width, height] = option.value.split('x').map(Number);
        return [width, height];
    });
};

// Utilitários para geração de Ad Unit Path
export const generateAdUnitPath = (
    provider: 'adp' | 'gpt',
    formatName: string, 
    position: string | undefined,
    managerType: string,
    networkId: string,
    domain: string,
): string => {
    if (!networkId || !domain) {
        return '';
    }
    const normalizedFormatName = formatName.replace(/-/g, '').toLowerCase();

    // Adiciona posição se existir
    const formatWithPosition = position ? `${normalizedFormatName}_${position}` : normalizedFormatName;

    let adUnitName = `${provider}_${formatWithPosition}`;
    
    if (managerType === 'account') {
        return `/${networkId}/${domain}/${adUnitName}`;
    }

    return `/PARENT_NETWORK_CODE,${networkId}/${domain}/${adUnitName}`;
};

// Função para validar se um tamanho é válido
export const isValidSize = (size: number[]): boolean => {
    return AVAILABLE_SIZES.some(availableSize => 
        availableSize[0] === size[0] && availableSize[1] === size[1]
    );
};

// Função para filtrar tamanhos válidos
export const filterValidSizes = (sizes: number[][]): number[][] => {
    return sizes.filter(isValidSize);
};
